import styled, { css } from 'styled-components'
import { DoctorRegisterStatus } from 'common/enum/doctor-register-status'

type WrapperProps = {
  backgroundColor?: string
  doctorStatus: DoctorRegisterStatus
}

const wrapperModifiers = {
  [DoctorRegisterStatus.UNREVIEWED_REGISTER]: css`
    background-color: transparent;
    border: 1px solid ${({ theme }) => theme.colors.lightGray};
    border-radius: 50%;
  `,
  [DoctorRegisterStatus.INCOMPLETE_REGISTER]: css`
    background-color: ${({ theme }) => theme.colors.white};
  `,
  [DoctorRegisterStatus.PENDENT]: css`
    background-color: ${({ theme }) => theme.colors.orange};
  `,
  [DoctorRegisterStatus.REVIEWED_BY_DIRECTOR]: css`
    background-color: ${({ theme }) => theme.colors.orange};
  `,
  [DoctorRegisterStatus.APPROVED_BY_DIRECTOR_WITH_PENDENCIES]: css`
    background-color: ${({ theme }) => theme.colors.greyishBlue};
  `,
  [DoctorRegisterStatus.PENDENCY_ANSWERED]: css`
    background-color: ${({ theme }) => theme.colors.greyishBlue};
  `,
  [DoctorRegisterStatus.REGISTER_SEND_TO_DIRECTOR]: css`
    background-color: ${({ theme }) => theme.colors.white};
  `,
  [DoctorRegisterStatus.REGISTER_RESEND_TO_DIRECTOR]: css`
    background-color: ${({ theme }) => theme.colors.white};
  `,
  [DoctorRegisterStatus.REGISTER_CONCLUDED]: css`
    background-color: ${({ theme }) => theme.colors.secondary};
  `,
  [DoctorRegisterStatus.REGISTER_REPROVED_BY_DIRECTOR]: css`
    background-color: ${({ theme }) => theme.colors.red};
  `
}

export const Wrapper = styled.div<WrapperProps>`
  height: 28px;
  width: 28px;
  position: relative;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.colors.lightGray};
  border: 0;
  ${({ doctorStatus }) => wrapperModifiers[doctorStatus]}
`

export const SubTitle = styled.span`
  font-size: ${({ theme }) => theme.font.sizes.xxxsmall};
  font-weight: ${({ theme }) => theme.font.black};
  color: ${({ theme }) => theme.colors.white};
  position: absolute;
  top: 50%;
  left: 50%;
  max-height: 28px;
  transform: translate(-50%, -50%);
`
